module.exports = __webpack_public_path__ + "img/37.7b9f3870.webp";